import DapDSTimelineItem from './timeline-item.component'

export * from './timeline-item.component'
export default DapDSTimelineItem

DapDSTimelineItem.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-timeline-item': DapDSTimelineItem
  }
}
